module.exports = __webpack_public_path__ + "img/utility_logo_dark.c1ac7631.png";